import React from 'react'
import { RenderDialogProps } from '../../../legacy-design-system/action/confirmation-action'
import { FetchResult } from 'react-apollo'
import { ConfirmationWarningDialog } from '../../../legacy-design-system/modal'
import { FormattedMessage } from 'react-intl'
import { VulnerabilityPoliciesDeleteMutation } from '../vulnerability-policies-delete-mutation'
import { logSuccess, logError } from '../../toaster'

interface ConfirmDeletePolicyDialogProps extends RenderDialogProps {
  readonly policyName: string
  readonly deletePolicy: () => Promise<FetchResult<any> | void>
}

interface DeleteDialogProps extends RenderDialogProps {
  readonly organizationUuid: string
  readonly policyID: string
  readonly policyName: string
  readonly refresh: () => Promise<any>
}

export function DeleteDialog({
  organizationUuid,
  policyID,
  policyName,
  refresh,
  ...props
}: DeleteDialogProps) {
  return (
    <VulnerabilityPoliciesDeleteMutation>
      {(deletePolicy) => {
        return (
          <FormattedMessage id="detail_vulnerabilityPolicy_deleteSuccessful">
            {(successMessage) => (
              <FormattedMessage id="detail_vulnerabilityPolicy_deleteFailure">
                {(errorMessage) => (
                  <ConfirmDeletePolicyDialog
                    {...props}
                    policyName={policyName}
                    deletePolicy={() => {
                      return deletePolicy({
                        variables: {
                          organizationID: organizationUuid,
                          id: policyID
                        }
                      })
                        .then(() => {
                          // eslint-disable-next-line @typescript-eslint/no-floating-promises
                          refresh()
                          logSuccess(successMessage as any)
                        })
                        .catch((error) => {
                          logError(errorMessage as any)
                          return error
                        })
                    }}
                  />
                )}
              </FormattedMessage>
            )}
          </FormattedMessage>
        )
      }}
    </VulnerabilityPoliciesDeleteMutation>
  )
}

function ConfirmDeletePolicyDialog({
  isOpen,
  closeDialog,
  policyName,
  deletePolicy
}: ConfirmDeletePolicyDialogProps) {
  return (
    <ConfirmationWarningDialog
      size="small"
      isOpen={isOpen}
      onCancel={closeDialog}
      onConfirm={() => {
        closeDialog()
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        deletePolicy()
      }}
      renderConfirmMessage={() => <FormattedMessage id="action_delete" />}
      renderCancelMessage={() => <FormattedMessage id="action_cancel" />}
      renderTitle={() => (
        <FormattedMessage id="title_remediationPolicy_deletePolicy" />
      )}
      renderBody={() => (
        <div>
          <FormattedMessage
            id="variable_deleteCompliancePolicyConfirmation_React"
            values={{ policyNameToDelete: <b>{policyName}</b> }}
          />
        </div>
      )}
    />
  )
}
